module.exports = __webpack_public_path__ + "static/media/spore-hunter.73689503.jpg";